import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import { ArticleHeaderAdSlot } from "~/components/article/article-header-ad-slot";
import { ArticleImageContainer } from "~/components/article/article-image/styles";
import { pageStyle } from "~/components/article/article-render/article-content/standard-styles";
import { StyledInlineAdSlot } from "~/components/content/content-schema-render/inline-ad-slot/styles";
import { StyledLi, StyledUl } from "~/components/content/content-schema-render/styles";
import { setFullViewportWidthStyles } from "~/lib/styles";

import { MorningStudioHeader } from "./header";

export const MorningStudioArticleContainer = styled.div`
  display: grid;
  grid:
    "header header header" min-content
    "header-ad-slot header-ad-slot header-ad-slot" min-content
    ". sub-headline ." min-content
    ". author ." min-content
    ". body ." min-content
    "footer-ad-slot footer-ad-slot footer-ad-slot" min-content
    ". topics ." min-content
    "disclaimer disclaimer disclaimer" min-content
    "footer-ad-slot-mobile footer-ad-slot-mobile footer-ad-slot-mobile" min-content
    ". . ." 10px
    / 1fr minmax(0, 680px) 1fr;

  ${props => props.theme.breakpoints.up("tablet")} {
    grid:
      "header header header header" min-content
      "header-ad-slot header-ad-slot header-ad-slot header-ad-slot" min-content
      ". sub-headline sub-headline ." min-content
      ". author author ." min-content
      ". body body ." min-content
      ". footer-ad-slot footer-ad-slot ." min-content
      ". topics social ." min-content
      "disclaimer disclaimer disclaimer disclaimer" min-content
      ". . . ." 10px
      / 1fr minmax(0, 440px) minmax(0, 240px) 1fr;
  }
`;

export const StyledMorningStudioHeader = styled(MorningStudioHeader)`
  grid-area: header;
`;

export const HeaderAdSlotDesktop = styled(ArticleHeaderAdSlot)`
  grid-area: header-ad-slot;

  display: none;

  ${props => props.theme.breakpoints.up("tablet")} {
    display: block;

    margin-block-start: 20px;
  }
`;

export const HeaderAdSlotMobile = styled.div`
  grid-area: header-ad-slot;

  display: block;

  ${props => props.theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const FooterAdSlot = styled.div`
  grid-area: footer-ad-slot;
`;

export const FooterAdSlotMobile = styled.div`
  ${setFullViewportWidthStyles()}
  grid-area: footer-ad-slot-mobile;

  display: block;

  margin-block-start: 40px;

  ${props => props.theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const SubHeadline = styled.div`
  grid-area: sub-headline;

  margin-block-start: 28px;
  margin-inline: 12px;

  font-weight: 300;
  font-size: 20px;
  font-family: ${fontRoboto};
  line-height: 25px;

  ${StyledUl} {
    padding-inline-start: 16px;
  }

  ${StyledLi} + ${StyledLi} {
    margin-block-start: 12px;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-inline: 0;

    font-size: 24px;
    line-height: 32px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    margin-block-start: 40px;
  }
`;

export const Author = styled.div`
  grid-area: author;

  margin-block-start: 20px;

  ${props => props.theme.breakpoints.up("desktop")} {
    margin-block-start: 40px;
  }
`;

export const Body = styled.div`
  grid-area: body;

  margin-block-start: 48px;

  ${StyledInlineAdSlot} {
    inline-size: 100%;
  }

  ${props => pageStyle(props)}

  ${props => props.theme.breakpoints.up("desktop")} {
    ${ArticleImageContainer} {
      margin-inline: -88px;
    }
  }
`;

export const Topics = styled.div`
  grid-area: topics;

  align-self: center;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-start: 40px;
  }
`;

export const Social = styled.div`
  grid-area: social;

  display: none;
  justify-self: end;
  align-self: center;

  ${props => props.theme.breakpoints.up("tablet")} {
    display: block;

    margin-block-start: 40px;
  }
`;

export const Disclaimer = styled.div`
  grid-area: disclaimer;

  margin-block-start: 40px;

  color: #666666;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
`;
